<script lang="ts" setup>
// import function to register Swiper custom elements
import {
  register,
  type SwiperContainer,
  type SwiperSlide,
} from "swiper/element/bundle";
import type {SwiperOptions} from "swiper/types";
import type {Partner} from "~/types/mgnl";
import type {Delivery} from "#magnolia-layer/types/api";
import ensureMinimumWithDuplicates from "~/utils/ensureMinimumWithDuplicates";

// register Swiper custom elements
register();

const swiperEl = ref<SwiperContainer | null>(null);

const runtimeConfig = useRuntimeConfig();
const {data: partners, error} = await useMagnoliaFetch<Delivery<Partner>>(
  runtimeConfig.public.mgnl.apiPartners,
  {
    transform: (input: Delivery<Partner>) => {
      return input.results;
    },
  },
);

const duplicatePartners = ref(true);
const loopedPartners = computed<Partner[]>(() => {
  if (duplicatePartners.value) {
    return ensureMinimumWithDuplicates(partners.value, 6);
  }
  return partners.value;
});

onMounted(() => {
  const el = swiperEl.value;
  if (!el) return;
  const swiperParams: SwiperOptions = {
    loop: true,
    freeMode: false,
    allowTouchMove: false,
    watchOverflow: true,
    resizeObserver: true,
    updateOnWindowResize: true,
    autoplay: {
      delay: 0,
      disableOnInteraction: false,
    },
    centerInsufficientSlides: true,
    slidesPerView: 1.5,
    spaceBetween: 60,
    speed: 7_000,
    breakpoints: {
      640: {
        slidesPerView: "auto",
        speed: 10_000,
      },
    },
    injectStyles: [
      `
      .swiper-wrapper {
        transition-timing-function: linear !important;
      }
      `,
    ],
    on: {
      // beforeResize(swiper) {
      //   duplicatePartners.value = swiper.width < partners.value.length * 480;
      //   swiper.update();
      // },
    },
  };
  Object.assign(el, swiperParams);
  const container = el as SwiperContainer;
  // if (container.clientWidth < partners.value.length * 480) {
  //   duplicatePartners.value = true;
  // }
  // nextTick(() => {
  container.initialize();
  // });
});
</script>

<template>
  <div
    class="col-span-full border-t-[1px] border-t-neutral-600 pt-22 pb-11 text-white flex flex-col gap-11">
    <div class="h-[140px]">
      <swiper-container
        ref="swiperEl"
        class="w-full h-[140px] absolute left-0 right-0 flex overflow-hidden"
        init="false">
        <swiper-slide
          v-for="partner in loopedPartners"
          class="flex items-center justify-center shrink-0 w-[480px]">
          <MagnoliaPicture
            :asset="partner.image"
            :class="{'grayscale brightness-[10]': partner.logoIsDiaP != true}"
            class="max-w-60"></MagnoliaPicture>
        </swiper-slide>
      </swiper-container>
    </div>
    <div class="inner-content-grid">
      <div
        class="col-span-full justify-self-end self-end uppercase text-sm pr-4">
        Partners
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
swiper-container {
  --swiper-wrapper-transition-timing-function: linear !important;
}
</style>
